import { MobileGenreStrip } from './MobileDiscovery';
import Catalog from "./Catalog";
import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import CarouselComponent from "./carosal";
import Searchresult from "./search";
import Api_key from "./apiconfiguration";
import GlassLoading from "./GlassLoading";
import useLoadTransition from "./useLoadTransition";
import ContinueWatching from "./ContinueWatching";
import AdaptiveHome from './AdaptiveHome';

const MovieComponent = ({search}) => {
  const [selectedGenre, setSelectedGenre] = useState('All');
  const [moviesByCategory, setMoviesByCategory] = useState({});
  const [loading, setLoading] = useState(true);
  const { showLoader, isContentVisible } = useLoadTransition(loading);
  
  const [error, setError] = useState(null);
  const apiKey = Api_key;
  

 
  const genres = [
    {
      "id": 28,
      "name": "Action"
    },
    {
      "id": 12,
      "name": "Adventure"
    },
    {
      "id": 16,
      "name": "Animation"
    },
    {
      "id": 35,
      "name": "Comedy"
    },
    {
      "id": 80,
      "name": "Crime"
    },
    {
      "id": 99,
      "name": "Documentary"
    },
    {
      "id": 18,
      "name": "Drama"
    },
    {
      "id": 10751,
      "name": "Family"
    },
    {
      "id": 14,
      "name": "Fantasy"
    },
    {
      "id": 36,
      "name": "History"
    },
    {
      "id": 27,
      "name": "Horror"
    },
    {
      "id": 10402,
      "name": "Music"
    },
    {
      "id": 9648,
      "name": "Mystery"
    },
    {
      "id": 10749,
      "name": "Romance"
    },
    {
      "id": 878,
      "name": "Science Fiction"
    },
    {
      "id": 10770,
      "name": "TV Movie"
    },
    {
      "id": 53,
      "name": "Thriller"
    },
    {
      "id": 10752,
      "name": "War"
    },
    {
      "id": 37,
      "name": "Western"
    }
  ]; 

  useEffect(() => {
    const fetchMovies = async () => {
      try {
        const [genreResponses, latestMoviesResponse] = await Promise.all([
          Promise.all(
            genres.map((genre) =>
              axios.get(
                `https://api.themoviedb.org/3/discover/movie?api_key=${apiKey}&with_genres=${genre.id}&page=1`
              )
            )
          ),
          axios.get(
            `https://api.themoviedb.org/3/movie/now_playing?api_key=${apiKey}&page=1`
          ),
        ]);

        const categoryResults = genres.reduce((results, genre, index) => {
          results[genre.name] = genreResponses[index].data.results || [];
          return results;
        }, {});
        categoryResults["Latest Releases"] =
          latestMoviesResponse.data.results || [];

        setMoviesByCategory(categoryResults);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    
      fetchMovies();
    
    
  }, []);


  if (search) return <Searchresult search={search} />;
  if (error) return <p>Error loading movies: {error}</p>;

  return (
    <div className='page-stage'>
      {showLoader && (
        <div className={`page-loader-layer ${loading ? '' : 'is-exiting'}`}>
          <GlassLoading variant="catalog" label="Loading movie collections" />
        </div>
      )}
      <div className={`page-reveal ${isContentVisible ? 'is-visible' : ''}`}>
          <>
        <MobileGenreStrip categories={moviesByCategory} selected={selectedGenre} onSelect={setSelectedGenre} />
          <CarouselComponent selection={selectedGenre === 'All' ? null : moviesByCategory[selectedGenre]?.slice(0,7)} />
      <ContinueWatching />
      <AdaptiveHome />
      <Catalog categories={moviesByCategory} mediaType="movie" selectedGenre={selectedGenre} onGenreChange={setSelectedGenre} />
      </>
      </div>
    </div>
  );
};

export default MovieComponent;
